import { State, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { InstituteDetailModelState } from './institute-detail-model';
import { AddInstituteDetail } from './institute-detail-actions';

@State<InstituteDetailModelState>({
  name:'instituteDetail',
  defaults:{
    items:[]
  }
})
@Injectable()
export class InstituteDetailState{

  constructor()  {
  }

  @Action(AddInstituteDetail)
  addInstituteDetail(ctx: StateContext<InstituteDetailModelState>, action: AddInstituteDetail) {
    const state = ctx.getState();
    if(!state.items.find(item=>item.id==action.payload.item.id))
    {
      ctx.setState({
        ...state,
        items: [...state.items, action.payload.item]
      });
    }
  }
}
